import { Box } from "@chakra-ui/react";

interface Props {
  color: string;
  size?: string;
  [key: string]: any;
}

export const ColorIndicator = ({ color, size = "20px", ...props }: Props) => {
  return (
    <Box
      width={size}
      height={size}
      borderRadius="50%"
      backgroundColor={color}
      display="inline-block"
      {...props}
    />
  );
};
